/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// papercrush:start — Spiff-Button-Positionierung (Session 1 Port, 11.06.2026)
// ABHÄNGIGKEIT: erwartet globale Liquid-Variable `isAvailable` (wird in main-product gerendert).
// Wird in der Critical-Diff-Session aufgelöst; bis dahin wirft dieser Block auf Seiten ohne `isAvailable` einen ReferenceError.
// Positionierung und Verhalten von Personalisierungs Containern

document.addEventListener("DOMContentLoaded", function() {
 
    let button1 = document.querySelector('.product-form__add-button');
    let button2 = document.querySelector('.spiff-button');
    let paymentContainer = document.querySelector('.product-form__payment-container');

    // Wenn button2 und paymentContainer existieren, verschiebe button2 in paymentContainer
    if (button2 && paymentContainer) {
        paymentContainer.appendChild(button2);
    }

    // Positioniere den paymentContainer und die Buttons
    if (paymentContainer) {
        paymentContainer.style.position = 'relative';
    }

    if (button1) {
        button1.style.position = 'relative';
        button1.style.zIndex = '2';
    }

    if (button2) {
        button2.style.position = 'absolute';
        button2.style.top = '0';
        button2.style.left = '0';
        button2.style.zIndex = '1';
    }

    // Wenn das Produkt nicht verfügbar ist und der spiff-button existiert, blende ihn aus
    if (!isAvailable && button2) {
        button2.style.cssText = "display: none !important;";
    }

    // Überprüfe, ob beide Buttons vorhanden sind, bevor der Rest des Codes ausgeführt wird
    if (button1 && button2) {
        // Setze die Breite und Höhe von Button 2 auf die von Button 1
        let widthButton1 = getComputedStyle(button1).width;
        let heightButton1 = getComputedStyle(button1).height;
        button2.style.width = widthButton1;
        button2.style.height = heightButton1;  
    }
  
    let container1 = document.getElementById('container1');
    let container2 = document.getElementById('container2');

    if (container1 && container2) {
        container1.addEventListener('click', function() {
            button1.style.visibility = 'visible';
            if (button2) button2.style.visibility = 'hidden';
            container1.classList.add('selected');
            container2.classList.remove('selected');
        });

        container2.addEventListener('click', function() {
            button1.style.visibility = 'hidden';
            if (button2) button2.style.visibility = 'visible';
            container2.classList.add('selected');
            container1.classList.remove('selected');
        });
    }
});
// papercrush:end

// papercrush:start — Galerie-Slider-Pfeile (Critical-Diff-Session 15.06.2026)
// Port des Live-Verhaltens: Stock 7.0.1 rendert keine Karussell-Pfeile.
// Markup-Buttons in snippets/product-gallery.liquid, Optik in assets/papercrush-custom.css.
// Dieser Handler ist top-level (NICHT im DOMContentLoaded-Spiff-Block oben), damit er
// unabhaengig vom isAvailable-ReferenceError funktioniert. Er steuert die theme-eigene
// Thumbnail-Navigation an: ein Klick auf das naechste/vorige .product-gallery__thumbnail
// (:not(.is-filtered)) triggert die in theme.js verdrahtete selectCell-Navigation. Wrap-around.
document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.pc-gallery-arrow');
    if (!arrow) return;
    event.preventDefault();

    var gallery = arrow.closest('.product-gallery');
    if (!gallery) return;

    var thumbnails = Array.prototype.slice.call(
        gallery.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)')
    );
    if (thumbnails.length < 2) return;

    var currentIndex = thumbnails.findIndex(function (thumb) {
        return thumb.classList.contains('is-nav-selected');
    });
    if (currentIndex === -1) currentIndex = 0;

    var direction = arrow.classList.contains('pc-gallery-arrow--next') ? 1 : -1;
    var nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;

    thumbnails[nextIndex].click();
});
// papercrush:end